import React, { useState, useEffect } from "react";
import useFetch from "Hooks/useFetch";
import Spinner from "Components/RequestHandler/Spinner";
import AboutUsBanner from "./Components/AboutUsBanner";
import AboutUsContent from "./Components/AboutUsContent";
const AboutUsPage = () => {
  const { fetchData, isLoading } = useFetch();
  const [aboutData, setAboutData] = useState(null);

  const fetchAboutData = async () => {
    const data = await fetchData("aboutus");
    console.log(data, "from about");
    setAboutData(data?.data);
  };

  useEffect(() => {
    fetchAboutData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center mt-10 min-h-screen">
        <Spinner />
      </div>
    );
  }

  if (aboutData) {
    return (
      <main>
        <AboutUsBanner
          bannerTitle={aboutData?.bannerTitle}
          bannerImage={aboutData?.bannerImage}
        />
        <AboutUsContent data={aboutData} />
      </main>
    );
  }
};

export default AboutUsPage;
